export var PriceEndpoints;
(function (PriceEndpoints) {
    // GET /prices?provider=:provider&fromCrypto=:fromCrypto&toFiat=:toFiat&amount=:amount&network=:network
    PriceEndpoints.VALID_PROVIDERS = ['alchemypay', 'moonpay', 'transak'];
    PriceEndpoints.VALID_CRYPTO_CURRENCIES = ['usdc', 'usdce', 'usdc.e', 'usdt'];
    PriceEndpoints.VALID_FIAT_CURRENCIES = ['eur', 'ars', 'brl'];
    // Validation functions
    PriceEndpoints.isValidProvider = (value) => typeof value === 'string' && PriceEndpoints.VALID_PROVIDERS.includes(value.toLowerCase());
    PriceEndpoints.isValidCryptoCurrency = (value) => typeof value === 'string' && PriceEndpoints.VALID_CRYPTO_CURRENCIES.includes(value.toLowerCase());
    PriceEndpoints.isValidFiatCurrency = (value) => typeof value === 'string' && PriceEndpoints.VALID_FIAT_CURRENCIES.includes(value.toLowerCase());
})(PriceEndpoints || (PriceEndpoints = {}));
